// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import SelectUserModal from '../../modals/select_user_modal'

up.compiler('[change-box-owner]', (element, data) => {
  up.on(element, 'click', function(e) {
    e.preventDefault()
    e.stopPropagation()

    const ownerChangeUrl = data.change_box_owner_url

    new SelectUserModal().open().then((user) => {
      if (!user) { return }

      up.visit(ownerChangeUrl, {
        params: { user_id: user.id },
        target: '.modal',
        history: false,
      })
    })
  })
})
